var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M17.3895 15.67L13.3495 12H10.6395L6.59949 15.67C5.46949 16.69 5.09949 18.26 5.64949 19.68C6.19949 21.09 7.53949 22 9.04949 22H14.9395C16.4595 22 17.7895 21.09 18.3395 19.68C18.8895 18.26 18.5195 16.69 17.3895 15.67ZM13.8195 18.14H10.1795C9.79949 18.14 9.49949 17.83 9.49949 17.46C9.49949 17.09 9.80949 16.78 10.1795 16.78H13.8195C14.1995 16.78 14.4995 17.09 14.4995 17.46C14.4995 17.83 14.1895 18.14 13.8195 18.14Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M18.3506 4.32C17.8006 2.91 16.4606 2 14.9506 2H9.05065C7.54065 2 6.20065 2.91 5.65065 4.32C5.11065 5.74 5.48065 7.31 6.61065 8.33L10.6506 12H13.3606L17.4006 8.33C18.5206 7.31 18.8906 5.74 18.3506 4.32ZM13.8206 7.23H10.1806C9.80065 7.23 9.50065 6.92 9.50065 6.55C9.50065 6.18 9.81065 5.87 10.1806 5.87H13.8206C14.2006 5.87 14.5006 6.18 14.5006 6.55C14.5006 6.92 14.1906 7.23 13.8206 7.23Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }